<template>
  <div class="FooterBottom">
    <a id="footer" href="#footer" accesskey="Z" title="下方導覽區塊">:::</a>
    <div class="wrapper">
      <div class="nav">
        <router-link to="/Privacy" title="隱私權政策">
          <p :style="{ fontSize: fontSize.p + 'em' }">隱私權政策</p>
        </router-link>
        <router-link to="/Website_Security" title="網站安全政策">
          <p :style="{ fontSize: fontSize.p + 'em' }">| 網站安全政策</p>
        </router-link>
        <router-link :to="{ name: 'NewsSubscription' }" title="電子報">
          <p :style="{ fontSize: fontSize.p + 'em' }">| 電子報</p>
        </router-link>
        <template v-for="(count, index) in upDateTime" :key="index">
          <span :style="{ fontSize: fontSize.p + 'em' }">
            | 瀏覽人次：{{ count.viewers }}
          </span>
          <span :style="{ fontSize: fontSize.p + 'em' }">
            | 更新日期：{{ count.updateTime }}
          </span>
        </template>
      </div>
      <div class="container">
        <div class="footer_group">
          <div class="item">
            <div class="pic">
              <img src="../../img/guide3.png" alt="勞動部勞動力發展署logo" />
            </div>
            <div class="txt">
              <img
                class="word"
                src="../../img/footerIcon.svg"
                alt="勞動部勞動力發展署logo"
              />
            </div>
          </div>
          <div class="footer_item">
            <div class="message">
              <p :style="{ fontSize: fontSize.p + 'em' }">
                地址：24219 新北市新莊區中平路439號南棟4樓
              </p>
              <p :style="{ fontSize: fontSize.p + 'em' }">
                電話代表號：(02)8995-6000
              </p>
              <a
                class="Email"
                href="mailto:wda@wda.gov.tw"
                :style="{ fontSize: fontSize.p + 'em' }"
              >
                電子信箱：wda@wda.gov.tw
              </a>
              <p :style="{ fontSize: fontSize.p + 'em' }">
                服務時間：週一至週五
              </p>
              <p :style="{ fontSize: fontSize.p + 'em' }">
                上午8時30分至12時30分
              </p>
              <p :style="{ fontSize: fontSize.p + 'em' }">
                下午13時30分至17時30分
              </p>
            </div>
            <div class="in_left">
              <p :style="{ fontSize: fontSize.p + 'em' }">
                建議瀏覽器：Chrome，Firefox，IE10.0以上版本
              </p>
              <p :style="{ fontSize: fontSize.p + 'em' }">
                (螢幕最佳顯示效果為1920 * 1280)
              </p>
            </div>
          </div>
        </div>
        <div class="footer_item phone_disappear">
          <div class="pic">
            <a
              href="https://accessibility.moda.gov.tw/Applications/Detail?category=20240716173606"
              title="無障礙網站(另開新視窗)"
              target="_blank"
            >
              <img
                src="../../img/accessibility_mark.jpg"
                border="0"
                width="88"
                height="31"
                alt="通過AA無障礙網頁檢測"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//瀏覽人數計算
(function (i, s, o, g, r, a, m) {
  i["GoogleAnalyticsObject"] = r;
  (i[r] =
    i[r] ||
    function () {
      (i[r].q = i[r].q || []).push(arguments);
    }),
    (i[r].l = 1 * new Date());
  (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
  a.async = 1;
  a.src = g;
  m.parentNode.insertBefore(a, m);
})(window, document, "script", "//www.google-analytics.com/analytics.js", "ga");

ga("create", "UA-61754565-1", "auto");
ga("send", "pageview");

//  無障礙文字子層引入設定
import { reactive, inject } from "vue";
import { apiWeb, apiFocusNew } from "@/api/api.js";

export default {
  name: "FooterBottom",
  props: [],
  setup() {
    //  無障礙文字子層引入設定
    let fontSize = inject("fontSize");
    const upDateTime = reactive([]);

    apiWeb()
      .then((res) => {
        upDateTime.push(res.data);
      })
      .catch((err) => {
        console.log("流覽人數與更新日期失敗 ", err);
      });

    return {
      fontSize,
      upDateTime,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.nav {
  margin-bottom: 24px;
  a,
  span {
    color: #fff;
  }
}
.FooterBottom {
  background-color: $main_color;
  border-top: 5px solid $main_sec_color;
  @include md {
    margin-top: 40px;
  }
  #footer {
    width: auto;
    color: #fff;
    font-size: 2em;
    display: table-caption;
    margin-left: 16px;
  }
}
.footer_group {
  width: 80%;
  text-align: left;
  display: flex;
  justify-content: flex-start;
  align-content: center;
  @include xl {
    flex-direction: column;
    align-items: center;
  }
  .item {
    width: 8%;
    @include CulFlex_center();
    margin-right: 110px;
    transform: translateX(30px);
    @include xxl {
      width: 13%;
    }
    @media screen and (max-width: 1400px) {
      transform: translateX(47px);
    }
    @include xl {
      transform: translateX(0px);
      margin: 0 auto 20px;
    }
    @include lg {
      width: 13%;
    }
    @include md {
      width: 15%;
    }
    @include xs {
      width: 25%;
    }
    .pic {
      width: 65%;
    }
    @media screen and (max-width: 992px) {
      width: 15%;
    }
    @include md {
      width: 20%;
    }
    @include xs {
      width: 25%;
    }
    .txt {
      display: flex;
      justify-content: center;
      width: 168%;
      margin-top: 15px;
      @include xxl {
        width: 130%;
      }
      @media screen and (max-width: 1400px) {
        width: 145%;
      }
      @media screen and (max-width: 992px) {
        width: 250%;
        margin-top: 10px;
      }
      img {
        width: 100%;
      }
    }
  }
}
.footer_item {
  &.phone_disappear {
    @include xl {
      width: 40%;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      margin-top: 20px;
    }
    @include lg {
      width: 50%;
    }
    @media screen and (max-width: 800px) {
      width: 55%;
    }
    @include md {
      width: 60%;
    }
    @media screen and (max-width: 670px) {
      width: 73%;
    }
    @include sm {
      width: 80%;
    }
    @include xs {
      flex-direction: column;
      align-items: flex-start;
    }
  }
  line-height: 1.7;
  @include a_size();
  .message {
    padding: 0;
    @include CulFlex_center();
    align-items: flex-start;
    @include xl {
      padding: 0px 0 20px;
    }
    @include lg {
      padding: 20px 0 20px;
    }
    .Email {
      color: #fff;
    }
  }
  .txt {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .in_left {
    @include flex_center();
    padding-top: 30px;
    @include xl {
      padding-top: 0;
    }
    @media screen and (max-width: 1580px) {
      align-items: flex-start;
      flex-direction: column;
    }
  }
  .pic {
    width: 50%;
    margin-top: 50px;
    @include xl {
      width: 30%;
    }
    @include lg {
      width: 40%;
    }
    @include xs {
      margin-top: 20px;
    }

    img {
      width: 100%;
    }
  }
  a {
    p {
      color: #fff;
    }
  }
}
.container {
  padding: 45px 170px;
  @include flex_between();
  color: #fff;
  @media screen and (max-width: 1550px) {
    padding: 45px 180px;
  }
  @media screen and (max-width: 1400px) {
    padding: 45px 120px;
    justify-content: center;
  }
  @include xl {
    flex-direction: column;
    padding: 45px 40px;
  }
}
</style>
